import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

export default function TableMembers({ collection }) {
  const conditionalRowStyles = [
    {
      when: (row) => row.attributes.format_terminated_date != "",
      style: {
        backgroundColor: "red",
        color: "white",
      },
    },
  ];

  const columns = [
    {
      name: "Name",
      selector: "attributes.member_name",
      sortable: true,
      cell: (row) => (
        <a href={`/members/${row.attributes.member_id}/edit`} target="_blank">
          {row.attributes.member_name}
        </a>
      ),
    },
    {
      name: "Email",
      selector: "attributes.member_email",
      sortable: true,
    },
    {
      name: "Effective Date",
      selector: "attributes.format_effective_date",
      sortable: true,
    },
    {
      name: "Program Type",
      selector: "attributes.current_product",
      sortable: true,
    },
    {
      name: "Program Cost",
      selector: "attributes.format_employee_total_cost",
      sortable: true,
    },
    {
      name: "Payroll Frequency",
      selector: "attributes.pay_frequency",
      sortable: true,
    },
    {
      name: "Payroll Deduction",
      selector: "attributes.format_employee_pay_period",
      sortable: true,
    },
    {
      name: "Terminated",
      selector: "attributes.format_terminated_date",
      sortable: true,
    },
    {
      name: "Program",
      selector: "attributes.program",
      sortable: true,
    },
    {
      name: "Fully Paid",
      selector: "attributes.total_paid",
      sortable: true,
    },
  ];

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns}
        data={collection}
        noDataComponent="No records"
        conditionalRowStyles={conditionalRowStyles}
        persistTableHead={true}
      />
    </div>
  );
}
